<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">{{ title }}</h3>
                </div>
                <div class="col text-right">
                    <base-button @click.prevent="filterModal = true;" type="primary">
                        Spalten ein/ausblenden
                    </base-button>
                </div>
                <div class="col text-right">
                    <el-input
                        type="search"
                        class=""
                        clearable
                        prefix-icon="el-icon-search"
                        style="width: 250px"
                        placeholder="Suche"
                        v-model="search"
                        aria-controls="datatables"
                    >
                    </el-input>
                </div>
            </div>
        </div>
        <div>
            <modal v-model:show="modal" @close="modal = false"
                   modal-classes="modal-lg modal-dialog-centered">
                <template v-slot:header>
                    <h5 class="modal-title" id="modal-title-notification">{{ service.projectNr }} -
                        {{ service.projectName }}</h5>
                </template>
                <div class="row">
                    <div class="col col-lg-1">
                        <i title="Datum" class="fad fa-calendar"></i>
                    </div>
                    <div class="col">
                        <h5>{{ service.projectDate }}</h5>
                    </div>
                </div>
                <hr class="m-1">
                <div class="row">
                    <div class="col col-lg-1">
                        <i title="Mitarbeiter" class="fad fa-user"></i>
                    </div>
                    <div class="col">
                        <h2>{{ service.emplName }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-lg-1">
                        <i title="Beschreibung" class="fad fa-align-left"></i>
                    </div>
                    <div class="col">
                        <h4>{{ service.description }}</h4>
                    </div>
                </div>
                <hr class="m-1">
                <div class="row">
                    <div class="col col-lg-1">
                        <i title="Ansatz" class="fad fa-hourglass-start"></i>
                    </div>
                    <div class="col">
                        <h4>{{
                                parseFloat(service.approach).toLocaleString('de-CH', {
                                    style: 'currency',
                                    currency: 'CHF'
                                })
                            }} / {{ service.unit }}</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-lg-1">
                        <i title="Zeitaufwand" class="fad fa-clock"></i>
                    </div>
                    <div class="col">
                        <h4>{{ parseFloat(service.number).toFixed(2) }} {{ service.unit }}</h4>
                    </div>
                </div>
                <hr class="m-1">
                <div class="row">
                    <div class="col col-lg-1">
                        <i title="Betrag" class="fad fa-money-bill-wave"></i>
                    </div>
                    <div class="col">
                        <h4>
                            {{ parseFloat(service.amount).toFixed(2) }} {{ service.currency }}
                        </h4>
                    </div>
                </div>
                <template v-slot:footer>
                    <el-popover
                        placement="left"
                        title="Legende"
                        :width="250"
                        trigger="hover">
                        <span>LBV = <strong>L</strong>eistung <strong>b</strong>elastbar nach <strong>V</strong>ertrag</span><br>
                        <span>LNB = <strong>L</strong>eistung <strong>n</strong>icht <strong>b</strong>elastbar</span>
                        <template #reference>
                            <badge type="primary" class="mr-1 text-dark">{{ service.text }}</badge>
                        </template>
                    </el-popover>
                    <badge type="primary" class="text-dark">{{ (service.billingType) ? service.billingType : '' }} <i
                        :class="{'fad fa-check-circle text-success': (service.billingType === 'Abgerechnet'), 'fad fa-cash-register text-danger': (service.billingType === 'Abzurechnen'), 'fad fa-handshake text-primary': (service.billingType && service.billingType.includes('Kulant'))}"></i>
                    </badge>
                    <base-button type="primary"
                                 class="ml-auto"
                                 @click="modal = false">
                        Schliessen
                    </base-button>
                </template>
            </modal>
            <modal v-model:show="filterModal" @close="filterModal = false"
                   modal-classes="modal-sm modal-dialog-centered d-flex justify-content-center">

                    <div v-for="(column, key) in table" class="ml-3">
                        <el-checkbox v-model="table[key].visible" :label="column.header"></el-checkbox>
                    </div>
                    <base-button class="resetFilter ml-3" title="zurücksetzen" @click.prevent="resetTableColumns()"
                                 type="warning">
                        Zurücksetzen
                    </base-button>

                <div class="row ">
                </div>
            </modal>
        </div>
        <div class="table-responsive">
            <el-table @row-click="getService"
                      type="index"
                      ref="servicesTable"
                      class="table-responsive clickableRow"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                      :default-sort="{ prop: 'projectDate', order: 'descending' }"
                      empty-text="Keine Einträge vorhanden"
                      @sort-change="changeSort"
                      :data="filteredServices">
                <el-table-column prop="projectDate" label="Datum" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.projectDate.visible">
                    <template v-slot="{ row }">
                        {{ (row.projectDate) ? row.projectDate : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectNr" label="Nr." min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.projectNr.visible">
                    <template v-slot="{ row }">
                        {{ (row.projectNr) ? row.projectNr : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="Projekt" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.projectName.visible">
                    <template v-slot="{ row }">
                        {{ (row.projectName) ? row.projectName : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="emplName" label="Mitarbeiter" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.emplName.visible">
                    <template v-slot="{ row }">
                        {{ (row.emplName) ? row.emplName : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="billingType" label="Status" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.billingType.visible">
                    <template v-slot="{ row }">
                        {{ (row.billingType) ? row.billingType : '' }}
                        <i :class="getClass(row)"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="text" label="Leist.-Art" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.text.visible">
                    <template v-slot="{ row }">
                        {{ (row.text) ? row.text : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="Betrag" min-width="170px" sortable="custom"
                                 :sort-orders="['ascending', 'descending']" v-if="table.amount.visible">
                    <template v-slot="{ row }">
                        {{
                            (row.amount) ? parseFloat(row.amount).toLocaleString('de-CH', {
                                style: 'currency',
                                currency: 'CHF'
                            }) : ''
                        }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <base-button class="exportCSV" title="exportieren" @click.prevent="exportCSV()"
                         type="success">
                exportieren
            </base-button>
            <div class=""
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination v-model="pagination" :total="total" :perPage="perPage"></base-pagination>
            </div>
        </div>
        <base-alert v-if="error.length > 0" type="danger">
            <span class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        </base-alert>
    </div>

</template>
<script>
import moment from 'moment';
import UserService from '@/services/user.service';
import Modal from "@/components/Modal";
import BaseAlert from "@/components/BaseAlert";
import * as jsonexport from "jsonexport/dist";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption,
    ElCard,
    ElCheckbox
} from "element-plus";

export default {
    name: 'services-table',
    components: {
        Modal,
        BaseAlert,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElCard.name]: ElCard,
        [ElCheckbox.name]: ElCheckbox,
    },
    props: {
        type: {
            type: String
        },
        title: String
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        filteredServices() {
            if (this.search === '') {
                this.total = this.services.length;
                return this.services.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            } else {
                const entries = this.services.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.search.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.search.toLowerCase()) : prop.toString(10).toLowerCase().includes(this.search.toLowerCase())))
                });
                this.total = entries.length;
                return entries.filter((item, idx) => (idx >= this.start && idx < this.start + this.perPage));
            }
        },
    },
    methods: {
        getClass(row) {
            if (row.billingType === 'Abgerechnet') {
                return "fad fa-check-circle text-success"
            } else if (row.billingType === 'Abzurechnen') {
                return "fad fa-cash-register text-danger";
            } else {
                return "fad fa-handshake text-primary";
            }
        },
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable() {
            this.services.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (this.currentSort.includes('Nr') || this.currentSort === 'amount') {
                    if (parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort])) return -1 * modifier;
                    if (parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort])) return modifier;
                }
                if (this.currentSort.toLowerCase().includes('date')) {
                    if (a[this.currentSort].split('.').reverse().join('') < b[this.currentSort].split('.').reverse().join('')) return -1 * modifier;
                    if (a[this.currentSort].split('.').reverse().join('') > b[this.currentSort].split('.').reverse().join('')) return modifier;
                }
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        },
        getError(error) {
            if (error.response && error.response.status == '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status == '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        getServices() {
            UserService.getServices().then(
                response => {
                    this.services = response.data.data;
                    this.sortTable(this.currentSort);
                    this.total = response.data.recordsTotal;
                    this.error = '';
                    this.disabled = false;
                    this.$emit("changed", response.data);
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getService(service) {
            this.service = service;
            this.modal = true;
        },
        openFilter(){
            this.filterModal = true;
        },
        exportCSV() {
            let exported = []
            for (const service of this.services) {
                let data = {}
                for (const e in this.table) {
                    if (this.table[e].visible) {
                        data[this.table[e].CSVHeader] = service[e];
                    }
                }
                exported.push(data);
            }
            jsonexport(exported, {rowDelimiter: ';' }, (err, csv) => {
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/csv;charset=utf-16,' + encodeURIComponent(csv));
                element.setAttribute('download', 'Leistungen.csv');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            } )
        },
        getTableColumns() {

            if (sessionStorage.getItem('servicesTable') !== null) {
                return JSON.parse(sessionStorage.getItem('servicesTable'));
            } else {
                return {
                    projectDate: {visible: true, header: "Datum", key: "projectDate", CSVHeader: 'Datum'},
                    projectNr: {visible: true, header: "Nr", key: "projectNr", CSVHeader: 'Projektnummer'},
                    projectName: {visible: true, header: "Projekt", key: "projectName", CSVHeader: 'Projekt'},
                    emplName: {visible: true, header: "Mitarbeiter", key: "emplName", CSVHeader: 'Mitarbeiter'},
                    billingType: {visible: true, header: "Status", key: "billingType", CSVHeader: 'Status'},
                    amount: {visible: true, header: "Betrag", key: "amount", CSVHeader: 'Betrag'},
                    text: {visible: true, header: "Leist.-Art", key: "text", CSVHeader: 'Leistungsart'},
                };
            }
        },

        resetTableColumns() {
            this.table = {
                projectDate: {visible: true, header: "Datum", key: "projectDate", CSVHeader: 'Datum'},
                projectNr: {visible: true, header: "Nr", key: "projectNr", CSVHeader: 'Projektnummer'},
                projectName: {visible: true, header: "Projekt", key: "projectName", CSVHeader: 'Projekt'},
                emplName: {visible: true, header: "Mitarbeiter", key: "emplName", CSVHeader: 'Mitarbeiter'},
                billingType: {visible: true, header: "Status", key: "billingType", CSVHeader: 'Status'},
                amount: {visible: true, header: "Betrag", key: "amount", CSVHeader: 'Betrag'},
                text: {visible: true, header: "Leist.-Art", key: "text", CSVHeader: 'Leistungsart'},
            };
            sessionStorage.removeItem('servicesTable');
        }

    },
    created() {
        this.getServices();
        this.table = this.getTableColumns();
    },
    data() {
        return {
            services: [],
            service: {},
            modal: false,
            filterModal: false,
            currentSort: 'projectDate',
            currentSortDir: 'descending',
            search: '',
            disabled: true,
            error: '',
            newRequest: '',
            pagination: 1,
            total: 0,
            start: 0,
            perPage: 6,
            table: {},
        }
    },
    watch: {
        pagination() {
            this.start = (this.pagination - 1) * this.perPage;
        },
        table: {
            handler(value) {
                sessionStorage.setItem('servicesTable', JSON.stringify(value));
            }, deep:true
        } ,
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.loader {
    height: 100%;
}

.loaderInfo {
    padding: 0;
    margin: 0;
    background: white;
    height: 4em;
}

.ck-editor__editable {
    min-height: 150px;
}
.exportCSV {
    line-height: 0.5!important;
    height: 36px;
    overflow: hidden!important;
}
thead th {
    cursor: pointer;
}

</style>
